import React from "react";
import { motion } from "framer-motion";
import { Navigation, Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { BUSINESS, IMAGES } from "../data";

export const FinalCTA = () => (
  <section
    id="contact"
    data-testid="final-cta-section"
    className="relative py-24 md:py-36 scroll-mt-20 overflow-hidden"
  >
    <div className="absolute inset-0 z-0">
      <img
        src={IMAGES.exp2}
        alt="MEGAWIN5K gaming atmosphere in Jakarta"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/80" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-[#050505]" />
    </div>
    <div aria-hidden className="absolute left-1/4 top-1/2 w-[30rem] h-[30rem] rounded-full bg-violet/20 blur-[130px] z-0" />

    <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-12 text-center">
      <Reveal>
        <h2 className="font-display font-black text-4xl sm:text-5xl md:text-6xl tracking-tighter leading-none">
          Ready to Visit
          <span className="block text-neon mt-2">MEGAWIN5K?</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mt-8 text-base md:text-lg text-white/70 max-w-xl mx-auto leading-relaxed">
          Drop by our game store in {BUSINESS.region} for gaming and
          entertainment. Get directions or give us a call — we're open from{" "}
          {BUSINESS.opens}.
        </p>
      </Reveal>
      <Reveal delay={0.18}>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <a
            href={BUSINESS.directions}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-directions-btn"
            className="group inline-flex items-center gap-2 rounded-full bg-neon text-black font-bold px-8 py-4 hover:shadow-[0_0_30px_rgba(0,240,255,0.6)] transition-shadow duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
          >
            <Navigation size={18} className="transition-transform duration-300 group-hover:rotate-45" />
            Get Directions
          </a>
          <a
            href={BUSINESS.callLink}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-call-btn"
            className="inline-flex items-center gap-2 rounded-full bg-transparent border border-white/20 text-white font-bold px-8 py-4 hover:border-neon hover:text-neon transition-colors duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neon"
          >
            <Phone size={18} /> Call Now
          </a>
        </div>
      </Reveal>
      <Reveal delay={0.24}>
        <p className="mt-8 text-sm tracking-[0.15em] uppercase text-white/40">
          Visit MEGAWIN5K in Jakarta
        </p>
      </Reveal>
    </div>
  </section>
);
